import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, ControlLabel, Input, Form, SelectPicker, DatePicker } from 'rsuite'
import { isRequired, isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'
import moment from 'moment'

export default function ProposalAllDetailForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  handelPreview,
  clearValue,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)

  useEffect(() => {
    if (!clearValue) {
      setStartDate(null)
      setEndDate(null)
    }
  }, [clearValue])

  return (
    <Form>
      <Row>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            textAlign: 'right',
            color: '#2da888',
          }}
        >
          <b>
            <u>ผู้รับทุน</u>
          </b>
        </Col>
      </Row>

      <Row>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.firstNameGrantee.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <Input
            name={schema.firstNameGrantee.name}
            defaultValue={schema.firstNameGrantee.value}
            placeholder={schema.firstNameGrantee.hint || `ระบุชื่อ`}
            inputRef={register()}
          />
        </Col>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.lastNameGrantee.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <Input
            name={schema.lastNameGrantee.name}
            defaultValue={schema.lastNameGrantee.value}
            placeholder={schema.lastNameGrantee.hint || `ระบุนามสกุล`}
            inputRef={register()}
          />
        </Col>
      </Row>

      <Row>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.idCardGrantee.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <Input
            name={schema.idCardGrantee.name}
            defaultValue={schema.idCardGrantee.value}
            placeholder={schema.idCardGrantee.hint || `ระบุเลขที่บัตรประชาชน`}
            inputRef={register()}
          />
        </Col>
      </Row>

      <Row>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.telephoneGrantee.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <Input
            name={schema.telephoneGrantee.name}
            defaultValue={schema.telephoneGrantee.value}
            placeholder={schema.telephoneGrantee.hint || `ระบุเบอร์โทรศัพท์`}
            inputRef={register()}
          />
        </Col>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.emailGrantee.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <Input
            name={schema.emailGrantee.name}
            defaultValue={schema.emailGrantee.value}
            placeholder={schema.emailGrantee.hint || `ระบุอีเมล`}
            inputRef={register()}
          />
        </Col>
      </Row>

      <Row>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.organizationName.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <Input
            name={schema.organizationName.name}
            defaultValue={schema.organizationName.value}
            placeholder={schema.organizationName.hint || `ระบุชื่อองค์กร`}
            inputRef={register()}
          />
        </Col>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.taxId.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <Input
            name={schema.taxId.name}
            defaultValue={schema.taxId.value}
            placeholder={schema.taxId.hint || `ระบุเลขที่ผู้เสียภาษี`}
            inputRef={register()}
          />
        </Col>
      </Row>

      <hr />

      <Row>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            textAlign: 'right',
            color: '#2da888',
          }}
        >
          <b>
            <u>ผู้รับผิดชอบโครงการ</u>
          </b>
        </Col>
      </Row>

      <Row>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.firstNameResponsinator.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <Input
            name={schema.firstNameResponsinator.name}
            defaultValue={schema.firstNameResponsinator.value}
            placeholder={schema.firstNameResponsinator.hint || `ระบุชื่อ`}
            inputRef={register()}
          />
        </Col>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.lastNameResponsinator.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <Input
            name={schema.lastNameResponsinator.name}
            defaultValue={schema.lastNameResponsinator.value}
            placeholder={schema.lastNameResponsinator.hint || `ระบุนามสกุล`}
            inputRef={register()}
          />
        </Col>
      </Row>

      <Row>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.idCardResponsinator.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <Input
            name={schema.idCardResponsinator.name}
            defaultValue={schema.idCardResponsinator.value}
            placeholder={schema.idCardResponsinator.hint || `ระบุเลขที่บัตรประชาชน`}
            inputRef={register()}
          />
        </Col>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.telephoneResponsinator.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <Input
            name={schema.telephoneResponsinator.name}
            defaultValue={schema.telephoneResponsinator.value}
            placeholder={schema.telephoneResponsinator.hint || `ระบุเบอร์โทรศัพท์`}
            inputRef={register()}
          />
        </Col>
      </Row>

      <Row>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.emailResponsinator.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <Input
            name={schema.emailResponsinator.name}
            defaultValue={schema.emailResponsinator.value}
            placeholder={schema.emailResponsinator.hint || `ระบุอีเมล`}
            inputRef={register()}
          />
        </Col>
      </Row>
    </Form>
  )
}
